import React from "react";
import { useTranslation } from "react-i18next";
import NumberFormat, { NumberFormatValues } from "react-number-format";
import { defaultDeliveryTimeOptions } from "../../../../../../services/types";
import { getNumberOfMinutesFromNowToTheDate } from "../../../../../../services/utils";
import LiveOrderDeliveryTimeOption from "../LiveOrderDeliveryTimeOptions/LiveOrderDeliveryTimeOption";

interface Props {
	selectedTimeOption: number | undefined;
	setSelectedTimeOption: (option: number | undefined) => void;
	estimatedPreparationAt?: string;
	onChangeTimeOption: (option: number) => void;
	customMinutesValue: number | undefined;
	onChangeCutomMinutesInput: (cutomMinutesValue?: number) => void;
}

const MAX_MINUTES_VALUE = 60;

export const LiveOrderWoltChangeDataModalTimeOptions = ({
	selectedTimeOption,
	setSelectedTimeOption,
	estimatedPreparationAt,
	onChangeTimeOption,
	customMinutesValue,
	onChangeCutomMinutesInput,
}: Props) => {
	const { t } = useTranslation();
	const minutesFromNowToThePreparationDate = getNumberOfMinutesFromNowToTheDate(estimatedPreparationAt);
	const timeOptions = defaultDeliveryTimeOptions.filter(
		(timeOption) => timeOption + minutesFromNowToThePreparationDate <= MAX_MINUTES_VALUE
	);

	const customMinuteInputChange = ({ floatValue }: NumberFormatValues) => onChangeCutomMinutesInput(floatValue);

	const getCustomMinutesInputMaxValue = (): number => MAX_MINUTES_VALUE - minutesFromNowToThePreparationDate;

	const getIsNumberInputAllowed = ({ floatValue }: NumberFormatValues) =>
		!floatValue || floatValue + minutesFromNowToThePreparationDate <= MAX_MINUTES_VALUE;

	return (
		<div className="position-relative live-order-delivery-time-options">
			<h5>{t("modules.live_order.field.delay_preparation_time.title")}</h5>
			<div className="d-flex flex-wrap gap-2 align-items-center live-order-delivery-time-options-container">
				{timeOptions.map((timeOption) => (
					<LiveOrderDeliveryTimeOption
						key={timeOption}
						option={timeOption}
						selectedTimeOption={selectedTimeOption}
						setSelectedTimeOption={setSelectedTimeOption}
						handleSelect={onChangeTimeOption}
					/>
				))}
				<NumberFormat
					allowNegative={false}
					decimalScale={0}
					value={customMinutesValue ?? ""}
					onValueChange={customMinuteInputChange}
					placeholder={t("modules.live_order.action.provide_max_minutes_value.title", {
						max_minutes_value: getCustomMinutesInputMaxValue(),
					})}
					className="form-control custom-minutes-number-input flex-grow-1"
					isAllowed={getIsNumberInputAllowed}
					allowEmptyFormatting
				/>
			</div>
		</div>
	);
};
